<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{}">
</ng-container>

<ng-template #template
let-quickSearchTag="quickSearchTag">
  <div class="search-container" flexLayout="row" flexLayoutAlign="space-between center">
    <div flex="100">
      <input title={{title}}  id="searchInput" #searchinput matInput class="search-input" placeholder={{placeholder}}
        (keyup)="onKeyUp($event)" [ngModel]="search" focused="focused"/>
    </div>

    <div flex="2.5rem" matSuffix class="suffix">
      <mat-icon class="search-icon" aria-hidden="false" inline="true">search</mat-icon>
    </div>
  </div>
</ng-template>
